const RISKS_CONFIGS: IStudioOverallRiskConfigs = {
  '1': {
    text: 'Low',
    // #0ABF5B
    color: '#29B569',
    // #0ABF5B opacity 0.1
    backgroundColor: 'rgba(41, 181, 105, 0.12)',
  },
  '2': {
    text: 'Middle',
    // #FF9D00
    color: '#EDA53A',
    // #FF9D00 opacity 0.1
    backgroundColor: 'rgba(237, 165, 58, 0.12)',
  },
  '3': {
    text: 'High',
    // '#C51C1C',
    color: '#EF5858',
    // '#C51C1C' opacity 0.1
    backgroundColor: 'rgba(239, 88, 88, 0.12)',
  },
};

export { RISKS_CONFIGS };
